import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import axios, { AxiosResponse } from 'axios';
import { OutsourcingContractSetting } from 'src/entities/OutsourcingContractPdf.entity';
import requestUtil from 'src/utils/request.util';

export const queryKey = 'useOutsourcingContractSettingQuery';
const requestPath = '/api/v4/outsourcing_contract_setting';

const getRecord = async (): Promise<OutsourcingContractSetting> => {
  const response: AxiosResponse<OutsourcingContractSetting> = await axios.get(requestPath);
  return response.data;
};

export const useOutsourcingContractSettingQuery = (selectedCompanyId: number, enabled: boolean) => useQuery(
  [queryKey, { selectedCompanyId }],
  getRecord,
  {
    staleTime: Infinity,
    enabled: !!selectedCompanyId && enabled,
  }
);

export const useMutationOutsourcingContractSetting = () => {
  const queryClient = useQueryClient();

  return {
    create: useMutation(
      () => axios.post(requestPath),
      {
        onSuccess: () => {
            // eslint-disable-next-line no-void
            void queryClient.invalidateQueries([queryKey]);
        }
      }
    ),
    update: useMutation(
      (entity: OutsourcingContractSetting) => axios.put(requestPath, { data: requestUtil.convertKeysToSnakeCase(entity) }),
      {
        onSuccess: () => {
          // eslint-disable-next-line no-void
          void queryClient.invalidateQueries([queryKey]);
        },
        // エラー処理を追加
        onError: (error) => {
          console.error('Update failed:', error);
        }
      }
    ),
  };
};
